export default {
  baseURL: 'https://api.frotas-apresentacao.it4d.com.br/api/v1/',
  normalURL: 'https://api.frotas-apresentacao.it4d.com.br',
  mapApikey: 'AIzaSyDLn0rtU25-udA0WAACua5y7dzV8U-7MDc',
  consultApi: 'http://chronos.it4d.com.br/chronos/consult_position.php?placa=',
  localURL: 'https://frotas-apresentacao.it4d.com.br',
  wsHost: 'ws.frotas-apresentacao.it4d.com.br',
  wsPort: 443,
  wsKey: 'rydqertz1zyzlug6tl0u',
  wsForceTLS: true,
}